module.exports = __webpack_public_path__ + "img/landkreis_muehldorf_lernen.997f0a3.png";